<section class="home">
  <app-nav></app-nav>

  <!-- ═══════════════════════════════════════
       HERO
  ═══════════════════════════════════════ -->
  <section class="home__hero">
    <div class="hero__carousel">
      <img class="hero__slide" [class.active]="showA" [src]="heroA" alt="Hero A" />
      <img class="hero__slide" [class.active]="!showA" [src]="heroB" alt="Hero B" />
    </div>

    <div class="hero__overlay"></div>

    <div class="hero__content">
      <p class="hero__eyebrow">{{ 'PRINCIPAL.HERO.LOCATION' | translate }}</p>
      <h1 class="hero__title">
        {{ 'PRINCIPAL.HERO.TITLE_1' | translate }}<br>
        <span class="hero__accent">{{ 'PRINCIPAL.HERO.TITLE_2' | translate }}</span>
      </h1>
      <p class="hero__sub">{{ 'PRINCIPAL.HERO.SUBTITLE' | translate }}</p>

      <!-- SEARCH BAR -->
      <form class="hero__search" (ngSubmit)="onSearch()">
        <svg class="hero__searchIcon" width="18" height="18" fill="none" viewBox="0 0 24 24">
          <circle cx="11" cy="11" r="7" stroke="currentColor" stroke-width="2"/>
          <path d="M20 20l-3-3" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
        </svg>
        <input
          type="text"
          name="q"
          [(ngModel)]="query"
          [placeholder]="'PRINCIPAL.HERO.PLACEHOLDER' | translate"
          class="hero__searchInput"
          autocomplete="off"
        />
        <button class="hero__searchBtn" type="submit">
          <svg width="15" height="15" fill="none" viewBox="0 0 24 24">
            <circle cx="11" cy="11" r="7" stroke="#fff" stroke-width="2.2"/>
            <path d="M20 20l-3-3" stroke="#fff" stroke-width="2.2" stroke-linecap="round"/>
          </svg>
           {{ 'PRINCIPAL.HERO.SEARCH' | translate }}
        </button>
      </form> 

      <!-- QUICK TAGS -->
      <div class="hero__tags">
        <button class="hero__tag" type="button" (click)="quickSearch('Naturaleza')"><i class="fa-solid fa-mountain"></i> {{'PRINCIPAL.HERO.TAGS.NATURE' | translate}}</button>
        <button class="hero__tag" type="button" (click)="quickSearch('Café')"><i class="fa-solid fa-mug-hot"></i> {{'PRINCIPAL.HERO.TAGS.COFFEE' | translate}}</button>
        <button class="hero__tag" type="button" (click)="quickSearch('Senderismo')"><i class="fa-solid fa-person-hiking"></i> {{'PRINCIPAL.HERO.TAGS.HIKING' | translate}}</button>
        <button class="hero__tag" type="button" (click)="quickSearch('Cultura')"><i class="fa-solid fa-theater-masks"></i> {{'PRINCIPAL.HERO.TAGS.CULTURE' | translate}}</button>
        <button class="hero__tag" type="button" (click)="quickSearch('Gastronomía')"><i class="fa-solid fa-utensils"></i> {{'PRINCIPAL.HERO.TAGS.FOOD' | translate}}</button>
      </div>
    </div>

    <!-- PARTNERS STRIP (dentro del hero) -->
    <div class="hero__partners">
      <span class="hero__partnersLabel">{{ 'PRINCIPAL.HERO.COMPARE' | translate }}</span>
      <img src="https://res.cloudinary.com/dshqbl8d1/image/upload/v1765716044/Logo-Parque-Del-Cafe_bh5hsr.png" alt="Parque del Café">
      <img src="https://res.cloudinary.com/dshqbl8d1/image/upload/v1765716023/Booking.com_Logo.svg_bshdta.png" alt="Booking.com">
      <img src="https://res.cloudinary.com/dshqbl8d1/image/upload/v1765716786/TripAdvisor_Logo.svg_hwg548.png" alt="TripAdvisor">
      <img src="https://res.cloudinary.com/dshqbl8d1/image/upload/v1765717075/log_turismocity_2_qyydvt.jpg" alt="Turismocity">
      <img src="https://res.cloudinary.com/dshqbl8d1/image/upload/v1765716072/logo_mirum_afs1p5.png" alt="Mirum">
    </div>
  </section>

  <!-- ═══════════════════════════════════════
       SEARCH PANEL
  ═══════════════════════════════════════ -->
  @if (showPanel) {
    <div class="searchOverlay" (click)="closePanel()"></div>
    <div class="searchPanel" (click)="$event.stopPropagation()">
      <div class="searchPanel__head">
        <strong>{{ 'PRINCIPAL.SEARCH.RESULTS' | translate:{ query: query } }}</strong>
        <button type="button" (click)="closePanel()">✕</button>
      </div>
      @if (results.length === 0) {
        <app-empty
          type="search"
          [title]="'PRINCIPAL.SEARCH.NO_RESULTS' | translate:{query: query}"
          [description]="'PRINCIPAL.SEARCH.TRY' | translate">
        </app-empty>
      } @else {
        <div class="searchList">
          @for (r of results; track r.title) {
            <button type="button" class="searchItem" (click)="goResult(r)">
              <img *ngIf="r.img" [src]="r.img" alt="" />
              <div class="searchItem__text">
                <div class="searchItem__title">
                  <span class="searchItem__name">{{ r.title }}</span>
                  <span class="tag" [class.tagLugar]="r.kind==='lugar'" [class.tagCat]="r.kind==='categoria'">
                    {{ r.kind === 'categoria' ? 'Categoría' : 'Lugar' }}
                  </span>
                </div>
                <div class="searchItem__sub">{{ r.subtitle }}</div>
              </div>
            </button>
          }
        </div>
      }
    </div>
  }

  <!-- ═══════════════════════════════════════
       CATEGORÍAS
  ═══════════════════════════════════════ -->
  <section class="home__cats">
  <div class="home__catsInner">
    <h2 class="home__sectionTitle">{{ 'PRINCIPAL.CATEGORIES.TITLE' | translate }}</h2>
    <div class="home__catsGrid">

      <button class="cat__item" type="button" (click)="quickSearch('Glamping')">
        <div class="cat__icon cat__icon--img">
          <img src="https://res.cloudinary.com/dshqbl8d1/image/upload/v1773602272/glamping_zbuipr.webp" alt="Glamping">
        </div>
        <span>{{ 'PRINCIPAL.CATEGORIES.GLAMPING' | translate }}</span>
      </button>

      <button class="cat__item" type="button" (click)="quickSearch('Restaurante')">
        <div class="cat__icon cat__icon--img">
          <img src="https://res.cloudinary.com/dshqbl8d1/image/upload/v1773522135/restaurante_nu865m.webp" alt="Restaurante">
        </div>
        <span>{{ 'PRINCIPAL.CATEGORIES.RESTAURANT' | translate }}</span>
      </button>

      <button class="cat__item" type="button" (click)="quickSearch('Cafe')">
        <div class="cat__icon cat__icon--img">
          <img src="https://res.cloudinary.com/dshqbl8d1/image/upload/v1773601580/cafes_wisn4t.webp" alt="Café">
        </div>
        <span>{{ 'PRINCIPAL.CATEGORIES.CAFE' | translate }}</span>
      </button>

      <button class="cat__item" type="button" (click)="quickSearch('Actividad')">
        <div class="cat__icon cat__icon--img">
          <img src="https://res.cloudinary.com/dshqbl8d1/image/upload/v1773603516/actividad1_cuhpny.webp" alt="Actividad">
        </div>
        <span>{{ 'PRINCIPAL.CATEGORIES.ACTIVITIES' | translate }}</span>
      </button>

      <button class="cat__item" type="button" (click)="quickSearch('Senderismo')">
        <div class="cat__icon cat__icon--img">
          <img src="https://res.cloudinary.com/dshqbl8d1/image/upload/v1773601568/senderismo_ngirma.webp" alt="Senderismo">
        </div>
        <span>{{ 'PRINCIPAL.CATEGORIES.HIKING' | translate }}</span>
      </button>

      <button class="cat__item" type="button" (click)="quickSearch('Finca')">
        <div class="cat__icon cat__icon--img">
          <img src="https://res.cloudinary.com/dshqbl8d1/image/upload/v1773601589/finca-turistica_pzsjeu.webp" alt="Finca Turística">
        </div>
        <span>{{ 'PRINCIPAL.CATEGORIES.FARMS' | translate }}</span>
      </button>

      <button class="cat__item" type="button" (click)="quickSearch('Tour')">
        <div class="cat__icon cat__icon--img">
          <img src="https://res.cloudinary.com/dshqbl8d1/image/upload/v1773603630/tours1_dfnqde.webp" alt="Tour Operador">
        </div>
        <span>{{ 'PRINCIPAL.CATEGORIES.TOURS' | translate }}</span>
      </button>

      <button class="cat__item" type="button" (click)="quickSearch('Mirador')">
        <div class="cat__icon cat__icon--img">
          <img src="https://res.cloudinary.com/dshqbl8d1/image/upload/v1773601569/mirador_ss0bel.webp" alt="Mirador">
        </div>
        <span>{{ 'PRINCIPAL.CATEGORIES.VIEWPOINTS' | translate }}</span>
      </button>

    </div>
  </div>
</section>

  <!-- ═══════════════════════════════════════
       CARRUSELES DE PUEBLOS
  ═══════════════════════════════════════ -->
  <section class="home__start">
    <div class="home__startInner">
      <h2 class="home__sectionTitle home__sectionTitle--left">{{ 'PRINCIPAL.CAROUSEL.TITLE' | translate }}</h2>

      <!-- Carrusel 1 -->
      <div class="carousel__header">
        <h4 class="home__subTitle">{{ 'PRINCIPAL.CAROUSEL.NATURE' | translate }}</h4>
        <span class="carousel__seeAll" (click)="quickSearch('Naturaleza')"></span>
      </div>

      <div class="carousel__hint">
    <span class="carousel__hintIcon">↔</span>
    <span>{{ 'PRINCIPAL.CAROUSEL.SLIDE' | translate }}</span>
  </div>

      <div class="carousel__wrap">
        <div class="carousel__fadeL"></div>
        <div class="carousel__fadeR"></div>
        <div class="carousel__track carousel__track--slow">
          <!-- Items originales -->
          <button class="dest__card" type="button" (click)="goToTown('salento')">
            <img src="https://res.cloudinary.com/dshqbl8d1/image/upload/v1765719559/Salento_Portada-_carrucel_xhjred.jpg" alt="Salento">
            <div class="dest__overlay">
              <span class="dest__name">Salento</span>
              <span class="dest__region">Quindío</span>
            </div>
            <span class="dest__badge">{{ 'PRINCIPAL.CAROUSEL.BADGES.POPULAR' | translate }}</span>
          </button>
          <button class="dest__card" type="button" (click)="goToTown('filandia')">
            <img src="https://res.cloudinary.com/dshqbl8d1/image/upload/v1765722321/filandia_portada_-_carrucel_yvkncf.jpg" alt="Filandia">
            <div class="dest__overlay"><span class="dest__name">Filandia</span><span class="dest__region">Quindío</span></div>
          </button>
          <button class="dest__card" type="button" (click)="goToTown('calarca')">
            <img src="https://res.cloudinary.com/dshqbl8d1/image/upload/v1765722334/Parapente_wmwb6g.jpg" alt="Calarcá">
            <div class="dest__overlay"><span class="dest__name">Calarcá</span><span class="dest__region">Quindío</span></div>
          </button>
          <button class="dest__card" type="button" (click)="goToTown('montenegro')">
            <img src="https://res.cloudinary.com/dshqbl8d1/image/upload/v1765722352/Colombia_a5gesq.jpg" alt="Montenegro">
            <div class="dest__overlay"><span class="dest__name">Montenegro</span><span class="dest__region">Quindío</span></div>
          </button>
          <button class="dest__card" type="button" (click)="goToTown('quimbaya')">
            <img src="https://res.cloudinary.com/dshqbl8d1/image/upload/v1765722364/Quimbaya_xbe3wx.jpg" alt="Quimbaya">
            <div class="dest__overlay"><span class="dest__name">Quimbaya</span><span class="dest__region">Quindío</span></div>
          </button>
          <button class="dest__card" type="button" (click)="goToTown('circasia')">
            <img src="https://res.cloudinary.com/dshqbl8d1/image/upload/v1765722223/calarca_portada-_carrucel_oiqp2z.jpg" alt="Circasia">
            <div class="dest__overlay"><span class="dest__name">Circasia</span><span class="dest__region">Quindío</span></div>
            <span class="dest__badge dest__badge--new">{{ 'PRINCIPAL.CAROUSEL.BADGES.NEW' | translate }}</span>
          </button>
          
         
        </div>
      </div>

      <!-- Carrusel 2 -->
      <div class="carousel__header">
        <h4 class="home__subTitle">{{ 'PRINCIPAL.CAROUSEL.CULTURE' | translate }}</h4>
        <span class="carousel__seeAll" (click)="quickSearch('Café')"></span>
      </div>

      <div class="carousel__hint">
    <span class="carousel__hintIcon">↔</span>
    <span>{{ 'PRINCIPAL.CAROUSEL.SLIDE' | translate }}</span>
  </div>
      <div class="carousel__wrap">
        <div class="carousel__fadeL"></div>
        <div class="carousel__fadeR"></div>
        <div class="carousel__track carousel__track--rev">
          <!-- Items originales -->
          <button class="dest__card" type="button" (click)="goToTown('armenia')">
            <img src="https://res.cloudinary.com/dshqbl8d1/image/upload/v1765722373/armenia_ec3zfc.jpg" alt="Armenia">
            <div class="dest__overlay"><span class="dest__name">Armenia</span><span class="dest__region">Capital</span></div>
            <span class="dest__badge">{{ 'PRINCIPAL.CAROUSEL.BADGES.CITY' | translate }}</span>
          </button>
          <button class="dest__card" type="button" (click)="goToTown('buenavista')">
            <img src="https://res.cloudinary.com/dshqbl8d1/image/upload/v1765722223/buenavista_-_carrucel_dvsnw4.jpg" alt="Buenavista">
            <div class="dest__overlay"><span class="dest__name">Buenavista</span><span class="dest__region">Quindío</span></div>
            <span class="dest__badge">{{ 'PRINCIPAL.CAROUSEL.BADGES.POPULAR' | translate }}</span>
          </button>
          <button class="dest__card" type="button" (click)="goToTown('pijao')">
            <img src="https://res.cloudinary.com/dshqbl8d1/image/upload/v1765722387/pijao_portada_-_carrucel_upbjcz.jpg" alt="Pijao">
            <div class="dest__overlay"><span class="dest__name">Pijao</span><span class="dest__region">Slow City</span></div>
            <span class="dest__badge dest__badge--slow">{{ 'PRINCIPAL.CAROUSEL.BADGES.SLOW' | translate }}</span>
          </button>
          <button class="dest__card" type="button" (click)="goToTown('cordoba')">
            <img src="https://res.cloudinary.com/dshqbl8d1/image/upload/v1765722406/cordoba_lj5xsx.jpg" alt="Córdoba">
            <div class="dest__overlay"><span class="dest__name">Córdoba</span><span class="dest__region">Quindío</span></div>
          </button>
          <button class="dest__card" type="button" (click)="goToTown('tebaida')">
            <img src="https://res.cloudinary.com/dshqbl8d1/image/upload/v1765722418/la_tebaida_os8mgm.jpg" alt="La Tebaida">
            <div class="dest__overlay"><span class="dest__name">La Tebaida</span><span class="dest__region">Quindío</span></div>
          </button>
          <button class="dest__card" type="button" (click)="goToTown('genova')">
            <img src="https://res.cloudinary.com/dshqbl8d1/image/upload/v1765722432/genova_portada_-_carrucel_gg0fm4.jpg" alt="Génova">
            <div class="dest__overlay"><span class="dest__name">Génova</span><span class="dest__region">Quindío</span></div>
            <span class="dest__badge dest__badge--new">{{ 'PRINCIPAL.CAROUSEL.BADGES.NEW' | translate }}</span>
          </button>
          
          
        </div>
      </div>
    </div>
  </section>

  <!-- ═══════════════════════════════════════
       RECOMENDACIONES
  ═══════════════════════════════════════ -->
  <section class="home__reco">
    <div class="home__recoInner">
      <div class="home__recoHeader">
        <h2 class="home__sectionTitle home__sectionTitle--left">{{ 'PRINCIPAL.RECOMMENDATIONS.TITLE' | translate }}</h2>
      </div>
      <div class="home__recoGrid">
        <article class="home__card">
          <div class="home__cardImgWrap">
            <img src="https://res.cloudinary.com/dshqbl8d1/image/upload/v1765723800/cocora_3_hpqpvc.jpg" alt="Valle del Cocora">
            <div class="home__cardImgOverlay"></div>
          </div>
          <div class="home__cardBody">
            <span class="home__cardTag"><i class="fa-solid fa-mountain"></i> {{ 'PRINCIPAL.HERO.TAGS.NATURE' | translate }}</span>
            <h4>{{ 'PRINCIPAL.RECOMMENDATIONS.COCORA.TITLE' | translate }}</h4>
            <p>{{ 'PRINCIPAL.RECOMMENDATIONS.COCORA.DESC' | translate }}</p>
          </div>
        </article>
        <article class="home__card">
          <div class="home__cardImgWrap">
            <img src="https://res.cloudinary.com/dshqbl8d1/image/upload/v1765724011/parque_del_cafe_portada_-_sugerencias_wkryck.jpg" alt="Parque del Café">
            <div class="home__cardImgOverlay"></div>
          </div>
          <div class="home__cardBody">
            <span class="home__cardTag"><i class="fa-solid fa-fan"></i> {{ 'PRINCIPAL.HERO.TAGS.TOURISM' | translate }}</span>
            <h4>{{ 'PRINCIPAL.RECOMMENDATIONS.CAFE_PARK.TITLE' | translate }}</h4>
            <p>{{ 'PRINCIPAL.RECOMMENDATIONS.CAFE_PARK.DESC' | translate }}</p>
          </div>
        </article>
        <article class="home__card">
          <div class="home__cardImgWrap">
            <img src="https://res.cloudinary.com/dshqbl8d1/image/upload/v1765725012/Encanto_-_Filandia_Quindio_Colombia_d93yqk.jpg" alt="Mirador Encanto">
            <div class="home__cardImgOverlay"></div>
          </div>
          <div class="home__cardBody">
            <span class="home__cardTag"><i class="fa-solid fa-binoculars"></i> {{'PRINCIPAL.CATEGORIES.VIEWPOINTS' | translate}}</span>
            <h4>{{ 'PRINCIPAL.RECOMMENDATIONS.ENCANTO.TITLE' | translate }}</h4>
            <p>{{ 'PRINCIPAL.RECOMMENDATIONS.ENCANTO.DESC' | translate }}</p>
          </div>
        </article>
        <article class="home__card">
          <div class="home__cardImgWrap">
            <img src="https://res.cloudinary.com/dshqbl8d1/image/upload/v1765725175/avistamento_aves_portada_-_suge_kpizdw.jpg" alt="Avistamiento de aves">
            <div class="home__cardImgOverlay"></div>
          </div>
          <div class="home__cardBody">
            <span class="home__cardTag"><i class="fa-solid fa-dove"></i> Fauna</span>
            <h4>{{ 'PRINCIPAL.RECOMMENDATIONS.BIRDS.TITLE' | translate }}</h4>
            <p>{{ 'PRINCIPAL.RECOMMENDATIONS.BIRDS.DESC' | translate }}</p>
          </div>
        </article>
      </div>
    </div>
  </section>

  <!-- ═══════════════════════════════════════
       ALIADOS
  ═══════════════════════════════════════ -->
  <section class="home__allies" id="planes">
    <div class="home__alliesInner">
      <h2 class="home__sectionTitle">{{'PRINCIPAL.ALLIES.TITLE' | translate}}</h2>
      <div class="home__alliesGrid">
        <div class="home__ally"><img src="https://res.cloudinary.com/dshqbl8d1/image/upload/v1765716044/Logo-Parque-Del-Cafe_bh5hsr.png" alt="Parque del Café"></div>
        <div class="home__ally"><img src="https://res.cloudinary.com/dshqbl8d1/image/upload/v1765716023/Booking.com_Logo.svg_bshdta.png" alt="Booking.com"></div>
        <div class="home__ally"><img src="https://res.cloudinary.com/dshqbl8d1/image/upload/v1765716786/TripAdvisor_Logo.svg_hwg548.png" alt="TripAdvisor"></div>
        <div class="home__ally"><img src="https://res.cloudinary.com/dshqbl8d1/image/upload/v1765717075/log_turismocity_2_qyydvt.jpg" alt="Turismocity"></div>
        <div class="home__ally"><img src="https://res.cloudinary.com/dshqbl8d1/image/upload/v1765716072/logo_mirum_afs1p5.png" alt="Mirum"></div>
      </div>
    </div>
  </section>

</section>

<app-footer></app-footer>
